module.exports = __webpack_public_path__ + "static/media/home.d0c6b266.svg";